import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBaseCardStyles = makeStyles({
  root: {
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow4,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
});
